import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

import { TopupTransactionHistory } from '../../../../../core/models/topUpAccount.model';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';

@Component({
  selector: 'app-topup-history',
  imports: [CommonModule, PssLoadingComponent],
  templateUrl: './topup-history.component.html',
  styleUrl: './topup-history.component.css',
})
export class TopupHistoryComponent implements OnInit {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  token: string = '';
  uid: string = '';
  topupNumber: string = '';
  dataHistory: TopupTransactionHistory[] = [];
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private cookieService: CookieService,
    private apiTopUpService: ApiTopUpService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }
  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    this.topupNumber = this.cookieService.get('topupNumber');
    // this.topupNumber = this.languageService.getCookie('topupNumber');
    setTimeout(() => {
      this.getTopupTransactionHistory();
    }, 100);
  }

  /* ----------------------------------- Function ------------------------------------- */

  getTopupTransactionHistory() {
    console.log(this.topupNumber);

    this.dataHistory = [];
    if (this.uid && this.topupNumber) {
      this.isLoading = true;
      this.apiTopUpService
        .getTopupTransactionHistory(this.uid, this.topupNumber, this.token)
        .subscribe({
          next: (response: TopupTransactionHistory[]) => {
            console.log('getParkingCardInfo', response);
            this.dataHistory = response;
            this.isLoading = false;
          },
          error: (err) => {
            console.error('โหลดบัตรสมาชิกล้มเหลว', err);
            this.isLoading = false;
          },
        });
    } else {
      console.log('No data');
      return;
    }
  }

  goback() {
    this.router.navigate(['/top-up']);
  }
}
